<template>
  <PianoColtivazionDesktop v-if="!$vuetify.breakpoint.mobile" />
  <PianoColtivazioneMobile v-else />
</template>

<script>
import PianoColtivazionDesktop from "@/components/PianoColtivazione/Desktop/piano_coltivazione_desktop.vue"
import PianoColtivazioneMobile from "@/components/PianoColtivazione/Mobile/piano_coltivazione_mobile.vue"

export default {
  components: {
    PianoColtivazionDesktop,
    PianoColtivazioneMobile
  }
};
</script>

<style scoped>
</style>
